<template>
  <v-autocomplete
    :items="submitted"
    :label="label"
    v-model="selected"
    :multiple="multi"
    item-text="Id"
    item-value="Id"
  >
  
  <template slot="selection" slot-scope="data">
    {{data.item.Id}}: {{data.item.User.FirstName}} {{data.item.User.LastName}}
  </template>
  <template slot="item" slot-scope="props">
    <v-list-tile-content>
      <v-list-tile-title>
        {{props.item.Id}}: {{props.item.User.FirstName}} {{props.item.User.LastName}}
      </v-list-tile-title>
      <v-list-tile-sub-title>
        {{primarySite(props.item.PracticeSiteInformation)}}
      </v-list-tile-sub-title>
    </v-list-tile-content>
    </template>
 </v-autocomplete>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
const moduleNamespace = 'applications'
import moment from 'moment'
export default {
  name: 'app-select',
  props: {
    label: '',
    value: null,
    multi: false,
  },
  data() {
    return {
      items: [],
      selected: this.value,
    }
  },
  created() {
    //this.getSubmitted(moment(new Date()).format('MM/DD/YYYY'), moment(new Date()).add(-2, 'years').format('MM/DD/YYYY'))
  },
  methods: {
    ...mapActions(moduleNamespace, ['getSubmitted']),
    primarySite(list){
    
      let site = {}
      list.forEach(item => {
        if(item.IsPrimarySite){
          site = item
        }
      })
      if(site.SiteAddress && site.SiteAddress.SiteInsitutionName){
        return site.SiteAddress.SiteInsitutionName
      }
      return ''
    }
  },
  computed: {
    ...mapGetters(moduleNamespace, ['submitted']),
  },
  watch: {
    selected(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.selected = val
    },
  },
}
</script>
<style>
</style>